import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FetchSelect from '../../../core/form/FetchSelect';
import Column from '../../../core/layout/Column';
import Row from '../../../core/layout/Row';
import { Roles } from '../../../core/util';

const ModuleCustomizationListFilter = (props) => (
  <Row>
    {localStorage.role === Roles.ADMIN && (
      <Column size={6}>
        <FetchSelect
          url="distributors"
          label="Distributor"
          value={get(props.values, 'distributor', '')}
          onChange={(distributor) => {
            props.onChange('distributor', distributor);
            props.onSearch();
          }}
          resultTransformer={{ text: 'name', value: 'id' }}
        />
      </Column>
    )}
  </Row>
);

ModuleCustomizationListFilter.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

ModuleCustomizationListFilter.defaultProps = {
  values: {},
};

export default ModuleCustomizationListFilter;
